<div [style.max-width]="maxWidth" [style.max-height]="maxHeight">
  @if(extensao === 'pdf'){
    <div>
      @if(url !== null){
        <iframe #iframeRef [style.width]="'70vw'" [style.height]="'80vh'" [src]="!ignoreMiliseconds ? (url | safe) : getSafeUrl(url)" frameborder="0"
          style="border:none; display: block; margin: 0 auto;"></iframe>
      }
    </div>
  }@else{
    <div>
      @if(isDelete){
        <div (click)="deletar()" (keydown.enter)="deletar()" role="button" tabindex="0" class="delete-icon">
          <mat-icon>delete</mat-icon>
          <p>Excluir</p>
        </div>
      }
      <img [src]="!ignoreMiliseconds ? url : getSafeUrl(url)" alt="Visualização do arquivo">
    </div>
  }
</div>
